import React from "react";
import "./hootsuite-bar.sass";
import TintIcon from "../../../../../components/interface/icon/icon";
import { faCalendarCheck } from "@fortawesome/free-solid-svg-icons";
import { format } from "date-fns";
const HootsuiteBar = ({ date }) => {
  return /* @__PURE__ */ React.createElement("div", { className: "tint-hootsuite-bar" }, /* @__PURE__ */ React.createElement(TintIcon, { icon: faCalendarCheck }), /* @__PURE__ */ React.createElement("span", null, "Scheduled: ", format(date, "MM/dd/yyyy hh a")));
};
export default React.memo(HootsuiteBar);
